<template>
  <el-card>
    <div class="card-header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div class="card-content">
      <el-form :model="customer" :rules="rules" ref="customer" label-width="120px">
        <el-row>
          <el-form-item label="Title" prop="title">
            <el-select
              size="large"
              class="form-group border-input"
              placeholder="Select Title"
              v-model="customer.title"
            >
              <el-option
                v-for="option in titles"
                class
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Username" prop="username">
            <el-input class="pull-left" style="width:78%;" type="text" label="Username" placeholder="Username" disabled v-model="customer.username"></el-input>
            <el-button class="pull-right" type="success" v-on:click.prevent="toggleUsernameDialog()">Update Username</el-button>
          </el-form-item>

          <el-form-item label="Email" prop="email">
            <el-input type="email" label="Email" placeholder="Email" v-model="customer.email"></el-input>
          </el-form-item>

          <el-form-item label="First Name" prop="firstname">
            <el-input
              type="text"
              label="First Name"
              placeholder="First Name"
              v-model="customer.firstname"
            ></el-input>
          </el-form-item>
          <el-form-item label="Middle Name(s)" prop="middlenames">
            <el-input
              type="text"
              label="Middle Name(s)"
              placeholder="Middle Name(s)"
              v-model="customer.middlenames"
            ></el-input>
          </el-form-item>
          <el-form-item label="Last Name" prop="lastname">
            <el-input
              type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="customer.lastname"
            ></el-input>
           
          </el-form-item>
            <span v-if="!customer.shippingAddress">
              <small
                style="margin-left:5px"
                class="label label-danger">  No Address</small>
            </span>
            <span v-if="customer.shippingAddress">
            <el-form-item label="Phone" prop="phone">
              <el-input
                type="text"
                label="Phone"
                placeholder="Phone"
                
                v-model="customer.shippingAddress.phone"
              ></el-input>
            </el-form-item>

            <el-form-item label="Address" prop="address1">
              <el-input
                type="text"
                label="Address"
                placeholder="Address"
                v-model="customer.shippingAddress.line1"
              ></el-input>
            </el-form-item>
            <el-form-item label prop="address2">
              <el-input
                type="text"
                label="Address"
                placeholder="Address 2"
                v-model="customer.shippingAddress.line2"
              ></el-input>
            </el-form-item>
            <el-form-item label="Town/City" prop="town">
              <el-input
                type="text"
                label="Town"
                placeholder="Town"
                v-model="customer.shippingAddress.town"
              ></el-input>
            </el-form-item>
            <el-form-item label="Postcode" prop="postcode">
              <el-input
                type="text"
                label="Postcode"
                placeholder="Postcode"
                v-model="customer.shippingAddress.postcode"
              ></el-input>
            </el-form-item>
            <el-form-item label="Region" prop="region">
              <el-input
                type="text"
                label="Region"
                placeholder="Region"
                v-model="customer.shippingAddress.region"
              ></el-input>
            </el-form-item>
            <el-form-item label="Country" prop="country">
              <el-select
                value-key="id"
                class
                size="small"
                ref="selectedCountry"
                style="width:100%"
                v-model="customer.shippingAddress.country"
                placeholder="Select a product"
              >
                <el-option
                v-for="(country,index) in countries"
                  :value="index"
                  :label="country"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </span>
          <el-form-item label="Date of Birth" prop="dob">
            <el-date-picker
              v-model="customer.dateOfBirth"
              type="date"
              placeholder="Pick a day">
            </el-date-picker>
          </el-form-item>
         <!-- <el-form-item label="Gender" prop="gender">
            <p-radio label="Male" v-model="customer.gender">Male</p-radio>
            <p-radio label="Female" v-model="customer.gender">Female</p-radio>
          </el-form-item>-->
          <el-form-item label="Marketing" prop="acceptsMarketing">
            <el-switch v-model="customer.acceptsMarketing" active-text="Yes" inactive-text="No"></el-switch>
          </el-form-item>
          <el-form-item label="Has Paid" prop="hasPaid">
            <el-switch 
            v-model="customer.hasPaid" 
            active-text="Yes"
            :active-value=1
            inactive-text="No"
            :inactive-value=0></el-switch>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button type="primary" v-on:click.prevent="updateCustomer">Update Customer</el-button>
          <el-button v-on:click.prevent="toggleDialog()">Delete Customer</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog title="Confirm Delete" :visible.sync="dialogVisible" width="30%" :modal="false">
      <span>This will permanently delete the customer, are you sure?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="danger" @click="deleteCustomer()">Yes Delete</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Update Username" :visible.sync="usernameDialogVisible" width="30%" :modal="false">
      <p>Enter the new username below to update the username on both the admin and LMS.</p>
      <p><el-input type="text" label="New Userame" placeholder="Enter new username..." v-model="newUsername"></el-input></p>
      <br><p><strong>Please ensure you have entered the new username correctly before clicking update.</strong></p>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="usernameDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="setUsername()">Update Username</el-button>
      </span>
    </el-dialog>

  </el-card>
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
import LMSapi from "../../../api/lmsAPI";

export default {
  props: ["customer","countries"],

  data() {
    return {
      titles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      newUsername: '',
      dialogVisible: false,
      usernameDialogVisible: false,
      rules: {
        firstname: [
          {
            required: true,

            message: "Please input name",
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,

            message: "Please input name",
            trigger: "blur"
          }
        ],
        country: [
          { required: true, message: "Please add country", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    user(){
      const token = localStorage.getItem('vuex')
      const parsed = JSON.parse(token)
      return parsed['auth']
    }
  },
  methods: {
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    toggleUsernameDialog() {
      this.usernameDialogVisible = !this.usernameDialogVisible;
    },
    setUsername() {
      const updateUsername = LMSapi.setUsername({data:{newUsername: this.newUsername, oldUsername:this.customer.username}});
      Promise.resolve(updateUsername)
        .then(result => {
          console.log(result);
          this.customer.username = this.newUsername;
          this.customer.email = this.newUsername;
          this.updateCustomer();
          this.usernameDialogVisible = !this.usernameDialogVisible;
        })
        .catch(e => {
          console.log(e);
          this.$notify({
            title: "Error",
            message: "Can't connect to the LMS right now",
            type: "error"
          });
        });
    },
    updateCustomer() {
      this.customer.dateUpdated = moment().format();
      const q = gql`
        mutation update_customer($id: Int, $changes: Customer_set_input) {
          update_Customer(where: { id: { _eq: $id } }, _set: $changes) {
            affected_rows
            returning {
              id
              dateUpdated
            }
          }
        }
      `;
      
      this.$apollo
        /// You must strip out the nested objects and only send the customer object
        .mutate({
          mutation: q,
          variables: {
            id: this.customer.id,
            changes: _.omit(this.customer, [
              "shippingAddress",
              "__typename",
              "orders",
              "notes"
            ])
          }
        })
        .then(result => {
          this.$notify({
            title: "Updated",
            message: "Customer Updated",
            type: "success"
          });
          //return result;
          this.updateCustomerShippingAddress()
          this.saveNote('Auto Note - Customer information updated via admin')
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },
    updateCustomerShippingAddress(){
      this.customer.shippingAddress.dateUpdated = moment().format();
      const q = gql`
        mutation update_address($id: Int, $changes: Core_Address_set_input) {
          update_Core_Address(where: { id: { _eq: $id } }, _set: $changes) {
            affected_rows
            returning {
              id
              dateUpdated
            }
          }
        }
      `;

      this.$apollo
        /// You must strip out the nested objects and only send the customer object
        .mutate({
          mutation: q,
          variables: {
            id: this.customer.shippingAddress.id,
            changes: _.omit(this.customer.shippingAddress, [
          
              "__typename"
            ])
          }
        })
        .then(result => {
          this.$notify({
            title: "Updated Address",
            message: "Address Updated",
            type: "success"
          });
          //return result;
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },
    //SaveNote
    saveNote(newNote) {
      let q=gql`
      mutation AddNote {
        insert_Note(objects: {customerId: ${this.customer.id}, detail: "${newNote}", createdBy: "${this.user.email}",dateCreated:"${moment().format('YYYY-MM-DDTHH:mm:ss')}"}) {
          returning {
            id
            detail,
            createdBy,
            dateCreated
          }
        }
      } `
      this.$apollo
      .mutate({
        mutation: q
      }).then(result => {
        console.log(result)
        this.customer.notes.unshift(result.data.insert_Note.returning[0])
        this.$notify({
          title: "Note Saved",
          message: "Automatic note saved",
          type: "success"
        });
      }) 
    },
    deleteCustomer() {
      this.dialogVisible = !this.dialogVisible;
      const q = gql`
        mutation delete_customer($id: Int) {
          delete_Customer(where: { id: { _eq: $id } }) {
            affected_rows
          }
        }
      `;
      this.$apollo
        .mutate({ mutation: q, variables: { id: this.customer.id } })
        .then(result => {
          if (
            result.data.delete_Customer.affected_rows == 1 &&
            this.customer.shippingAddress.id
          ) {
            //delete the shippingAddress
            const d = gql`
              mutation delete_address($id: Int) {
                delete_Core_Address(where: { id: { _eq: $id } }) {
                  affected_rows
                }
              }
            `;
            this.$apollo
              .mutate({
                mutation: d,
                variables: { id: this.customer.shippingAddress.id }
              })
              .then(result => {
                this.$notify({
                  title: "Deleted",
                  message: "Customer Deleted",
                  type: "success"
                });
              });
          }
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/EditProfileForm.vue